import { API_BASE_URL } from "../../constants"
import { FreesoundClip } from "../../types/Freesound"
import axios from "../axios"

interface SearchParams {
  query: string
  page: number
  perPage: number
}

interface FreesoundResponse {
  freesounds: FreesoundClip[] // Consider specifying the exact type structure received from the API if known
  totalPages: number
}

export default function searchFreesounds({
  query,
  page,
  perPage,
}: SearchParams): Promise<FreesoundResponse> {
  const params = new URLSearchParams()

  params.append("query", query)
  params.append("page", page.toString())
  params.append("perPage", perPage.toString())

  return axios
    .get(`${API_BASE_URL}/freesounds/?${params.toString()}`)
    .then((response) => ({
      freesounds: response.data,
      totalPages: Number(response.headers["x-total-pages"]),
    }))
}
